export const QUOTES_CACHE_KEY = 'quotesCache';
export const ERROR_NO_QUOTES = 'ERROR_NO_QUOTES';
export const CYBER_ADDON_ID = '16001';
